import "./styles.css";
import { makeStyles } from "@material-ui/styles";
import img from "../assets/campus_picture.jpg";
import logo from "../assets/q1_answer.jpg";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
    // backgroundColor: "#000000"
  },
  img: {
    width: "100%",
    // height: "100vh",
    objectFit: "cover"
  },
  logo: {
    width: "100%"
  },
  paragraph: {
    marginVertical: 100,
    lineHeight: "3em"
  },
  contents: {
    paddingVertical: 100
  }
});

export default function App() {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div className={classes.root}>
      <img
        src={
          "https://drive.google.com/thumbnail?id=15-iQDvOUYsXjeYvQK3cL8PeCSgUhH8xK"
        }
        className={classes.img}
        alt="header"
      />
      <Box mx={50} sx={{ textAlign: "center" }}>
        <Box my={10}>
          <p className={classes.paragraph}>
            謎を解き　URLの空欄にblueと打ち込むと　サイトへのリンクが開かれた。
            <br />
            <br />
            <img src={logo} className={classes.logo} alt="header" />
            <br />
            <br />
            これくらいは簡単だったかな。
            <br />
            ？には、「十二月」が入り、それを組み合わせると「青」になる。
            <br />
            英語に直すと、「blue」となりこのサイトへと案内されるようになっていた。
            <br />
            さて、爆弾は千葉キャンパス内のある場所に置いた。
            <br />
            タイムリミットまでに特定できるかな…？
          </p>
        </Box>
        <Box my={10}>
          <Button
            onClick={() => {
              navigate("/quest_1");
            }}
            variant="contained"
            sx={{
              width: "30%",
              "&.MuiButton-contained": {
                backgroundColor: "#950623"
              }
            }}
          >
            特定する
          </Button>
        </Box>
      </Box>
    </div>
  );
}
